import * as zod from 'zod';

export const MIRAI_CONTROLLER_NAME_DEFAULT = 'MIRAI Controller';

export const MiraiControllerConfiguration = zod.object({
  kind: zod.literal('MiraiController'),
  id: zod.string().optional(),
  name: zod.string().default(MIRAI_CONTROLLER_NAME_DEFAULT),
  enabled: zod.boolean().default(true),
  host: zod.string().default('0.0.0.0'),
});

export type MiraiControllerConfiguration = zod.infer<
  typeof MiraiControllerConfiguration
>;
